import React from 'react'
import Layout from '../../layout';
import "../../layout/style.css"
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

function ResetSuccessful() {
    return (
        <Layout>
            <CheckCircleOutlineIcon style={{color: 'green', fontSize: '100px'}} />
            <Layout.Title>Your password has been changed</Layout.Title>
            <Layout.Paragraph>Thank you</Layout.Paragraph>
        </Layout>
    )
}

export default ResetSuccessful